import { Box, Breadcrumbs, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { app_title } from './../../config'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import getEligibilityCriteria from '../../hooks/GET/getEligibilityCriteria'

export default function EligibilityCriteria() {
	const { t } = useTranslation()
	const theme = useTheme()
	const [eligibilityCriteria, setEligibilityCriteria] = useState([])

	useEffect(() => {
		getEligibilityCriteria()
		.then((data) => {
			setEligibilityCriteria(data.data)
		})
		.catch((error) => console.log(error));
	}, [])

	return (
		<>
			<Helmet>
				<title>Partner - Eligibility Criteria {app_title && `| ${app_title}`}</title>
			</Helmet>
			<Box
				component="div"
				sx={{
					p: { sm: 0.5, md: 1 },
					width: "100%",
					maxWidth: "1600px",
					margin: "0 auto",
					overflowX: "hidden",
				}}
			>
				<Box mb={4}>
					<Typography
						variant="h5"
						fontWeight="bold"
						color="secondary.main"
						mb={1}
					>
						{t("Eligibility Criteria")}
					</Typography>
					<Breadcrumbs>
						<Link style={{ color: theme.palette.primary.main, textDecoration: "none" }} to="/partner">Dashboard</Link>
						<Link style={{ color: theme.palette.primary.main, textDecoration: "none" }} to="/partner/training-material">Training Material</Link>
						<Typography>Eligibility Criteria</Typography>
					</Breadcrumbs>
				</Box>

				<TableContainer>
					<Table>
						<TableHead>
							<TableRow sx={{ backgroundColor: '#FAFAFA' }}>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Criteria</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Age</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Salaried/Selfemployed</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Monthly net income</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Min loan</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Max loan</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Cibil</TableCell>
								<TableCell sx={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Lender Journey</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{eligibilityCriteria.map((row, index) => (
								<TableRow key={index} >
									<TableCell sx={{ border: '1px solid #ddd', fontWeight: 'bold', padding: '8px', textAlign: 'center' }}>{row.name || "-"}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.age || "-"}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.employment || "-"}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.income || "-"}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.min_loan || "-"}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.max_loan || "-"}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.cibil || "-"}</TableCell>
									<TableCell sx={{ border: '1px solid #ddd', background: 'primary', padding: '8px', textAlign: 'center' }}>{row.lender_journey || "-"}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Box>
		</>
	)
}
